export default __webpack_public_path__ + "static/media/account_registered.4af0bcae.svg";